(() => {
  const galleries = {"salt":[{"url":"https://cdn.shopify.com/s/files/1/0332/6201/0504/files/crystal-salt-lamp-gallery-1.png?v=1793674128","width":1280,"height":1280},{"url":"https://cdn.shopify.com/s/files/1/0332/6201/0504/files/car-diffuser-himalayan-tea-gallery-2.png?v=1793607132","width":1280,"height":1280},{"url":"https://cdn.shopify.com/s/files/1/0332/6201/0504/files/crystal-salt-lamp-gallery-3.png?v=1793674137","width":1280,"height":1280},{"url":"https://cdn.shopify.com/s/files/1/0332/6201/0504/files/crystal-salt-lamp-gallery-4.png?v=1793674118","width":2000,"height":2000},{"url":"https://cdn.shopify.com/s/files/1/0332/6201/0504/files/crystal-salt-lamp-gallery-5.png?v=1793674093","width":1122,"height":1122},{"url":"https://cdn.shopify.com/s/files/1/0332/6201/0504/files/crystal-salt-lamp-gallery-6.png?v=1793674105","width":1122,"height":1122}]};
  function setup() {
    const form = document.querySelector('form[data-product-handle="pristine-himalayan-salt-crystal-stone-lamp-set"]');
    const container = form?.closest('[data-section-type="product"]')?.querySelector('.product__media-container');
    if (!container || container.querySelector('[data-saltlamp-gallery]')) return;
    const gallery = document.createElement('div');
    gallery.dataset.saltlampGallery = ''; gallery.hidden = true;
    const main = document.createElement('button');
    main.type = 'button'; main.className = 'saltlamp-gallery__main';
    main.setAttribute('aria-label', container.querySelector('.product__media-action-button')?.getAttribute('aria-label') || 'Zoom image');
    const image = document.createElement('img');
    image.sizes = '(min-width: 720px) 50vw, 100vw'; main.append(image);
    const zoom = document.createElement('span'); zoom.textContent = '+'; zoom.setAttribute('aria-hidden', 'true'); main.append(zoom);
    const thumbs = document.createElement('div'); thumbs.className = 'saltlamp-gallery__thumbs';
    const dialog = document.createElement('dialog'); dialog.className = 'saltlamp-gallery__zoom';
    const close = document.createElement('button'); close.type = 'button'; close.textContent = '×'; close.setAttribute('aria-label', 'Close');
    const large = document.createElement('img'); dialog.append(close, large);
    gallery.append(main, thumbs, dialog); container.prepend(gallery);
    let selected = 0, items = [], activeKey = '';
    function select(index) {
      const item = items[index]; if (!item) return;
      selected = index; image.width = item.width; image.height = item.height;
      image.src = item.url + '&width=1280';
      image.srcset = [360,640,960,1280].filter(w => w <= item.width).map(w => item.url + '&width=' + w + ' ' + w + 'w').join(', ');
      if (dialog.open) large.src = item.url;
      image.alt = 'Himalayan Salt Lamp Set – image ' + (index + 1); large.alt = image.alt;
      [...thumbs.children].forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
    }
    main.addEventListener('click', () => { large.src = items[selected].url; dialog.showModal(); });
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault(); select((selected + (event.key === 'ArrowRight' ? 1 : items.length - 1)) % items.length);
      }
    });
    function update() {
      const key = 'salt';
      if (key === activeKey) return;
      activeKey = key; items = galleries[key] || [];
      if (dialog.open) dialog.close();
      gallery.hidden = !items.length;
      container.classList.toggle('saltlamp-gallery-active', Boolean(items.length));
      if (!items.length) return;
      thumbs.replaceChildren();
      items.forEach((item, index) => {
        const button = document.createElement('button'); button.type = 'button';
        const original = container.querySelectorAll('[data-product-thumbnail]')[index];
        button.setAttribute('aria-label', original?.getAttribute('aria-label') || 'Change image to image ' + (index + 1));
        const thumb = document.createElement('img'); thumb.src = item.url + '&width=240';
        thumb.width = 240; thumb.height = 240; thumb.alt = ''; thumb.loading = 'lazy';
        button.append(thumb); button.addEventListener('click', () => select(index)); thumbs.append(button);
      });
      select(0);
    }
    const style = document.createElement('style');
    style.textContent = `
      .saltlamp-gallery-active > :not([data-saltlamp-gallery]){display:none!important}
      [data-saltlamp-gallery][hidden]{display:none}
      .saltlamp-gallery__main{display:block;position:relative;width:100%;padding:0;border:0;background:transparent;cursor:zoom-in}
      .saltlamp-gallery__main img{display:block;width:100%;height:auto;aspect-ratio:1;object-fit:contain}
      .saltlamp-gallery__main>span{position:absolute;top:16px;right:16px;width:32px;height:32px;border-radius:50%;background:white;color:#8a857c;font-size:22px;line-height:32px}
      .saltlamp-gallery__thumbs{display:grid;grid-template-columns:repeat(6,minmax(0,1fr));gap:10px;margin-top:12px}
      .saltlamp-gallery__thumbs button{border:1px solid transparent;padding:0;background:transparent;cursor:pointer}
      .saltlamp-gallery__thumbs button[aria-pressed=true]{border-color:currentColor}
      .saltlamp-gallery__thumbs img{display:block;width:100%;height:auto;aspect-ratio:1;object-fit:cover}
      .saltlamp-gallery__zoom{padding:0;border:0;max-width:95vw;max-height:95dvh;background:transparent}
      .saltlamp-gallery__zoom::backdrop{background:rgba(0,0,0,.75)}
      .saltlamp-gallery__zoom img{display:block;max-width:95vw;max-height:90dvh;object-fit:contain}
      .saltlamp-gallery__zoom button{position:fixed;right:3vw;top:3vh;background:white;color:black;border:0;border-radius:50%;width:40px;height:40px;font-size:28px;cursor:pointer}
      .saltlamp-gallery__main:focus-visible,.saltlamp-gallery__thumbs button:focus-visible{outline:2px solid currentColor;outline-offset:3px}
      @media(max-width:719px){.saltlamp-gallery__thumbs{gap:6px;margin-top:8px}}
    `;
    gallery.append(style);
    let queued = false;
    form.addEventListener('change', () => {
      if (queued) return; queued = true;
      requestAnimationFrame(() => { queued = false; update(); });
    });
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
  document.addEventListener('shopify:section:load', setup);
})();
